<template>
  <el-dialog
    :visible.sync="endClassVisible"
    width="330px"
    top="30vh"
    class="comfirm-remove-dialog"
  >
    <div class="tips">是否确认全员下课</div>
    <div class="tips">如果想结束本课堂，请点击全员下课</div>

    <div class="footer">
      <el-button type="primary" @click="onConfirmEndClass">
        全员下课
      </el-button>
      <el-button
        v-if="showType === 'endButton'"
        @click="endClassVisible = false"
        >取消</el-button
      >
      <el-button v-if="showType === 'closeWindow'" @click="handleCloseWindow"
        >暂时离开</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import { closeWindow } from "@saas/components/src/utils/utils";
import { stopLive } from "@saas/service-api/src/live-sdk";
export default {
  props: {
    showType: {
      type: String,
      default: "endButton",
    },
  },
  data() {
    return {
      endClassVisible: false,
      isElectron: !!window.isElectron,
      lessonId: null,
    };
  },
  computed: {
    ...mapState("live", ["imService", "roomInfo", "liveService"]),
  },
  mounted() {
    this.lessonId = +this.$route.params.lessonId || "";
  },
  methods: {
    open() {
      this.endClassVisible = true;
    },
    onConfirmEndClass() {
      this.handleEndLive().then((res) => {
        if (res.code === 1 || res.code === 21003) {
          this.endClassVisible = false;
          this.afterEndClass();
        } else {
          this.$darkMessage.error(res.message);
        }
      });
    },
    handleEndLive() {
      this.imService.sendMGLiveRoomCustomMsg({
        cmdId: 2,
        data: {
          type: "endLive",
        },
      });
      return stopLive({
        room_id: this.roomInfo.id,
      });
    },
    afterEndClass() {
      if (this.isElectron) {
        window.ipcRenderer.send("end-class", {
          lessonId: this.lessonId,
          courseId: this.roomInfo.course_id,
        });
        closeWindow();
      } else {
        const url =
          "/live-list?liveover=1&lessonid=" +
          this.lessonId +
          "&courseid=" +
          this.roomInfo.course_id;
        window.location.href = url;
      }
    },
    handleCloseWindow() {
      this.liveService.exitRoom();
      closeWindow();
    },
  },
};
</script>

<style lang="scss" scoped>
.comfirm-remove-dialog ::v-deep {
  .el-dialog {
    width: 327px;
    background: #18181b;
    box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.06),
      0px 1px 3px 0px rgba(0, 0, 0, 0.1);
    border-radius: 12px 12px 12px 12px;
    border: 1px solid rgba(229, 231, 235, 0.04);
    padding: 16px;

    .el-dialog__header {
      display: none;
    }
    .el-dialog__body {
      padding: 0;
      font-size: 14px;

      text-align: center;
      .tips {
        line-height: 20px;
        color: #f7f8fa;
      }
      .el-checkbox {
        margin-top: 8px;
        .el-checkbox__input.is-checked {
          .el-checkbox__inner {
            background: #165dff;
            border-color: #165dff;
          }
        }
        .el-checkbox__inner {
          border-color: #165dff !important;
          &:hover {
            border-color: #165dff;
          }
        }
        .el-checkbox__label {
          color: #a1a1aa;
        }
      }
      .footer {
        margin-top: 16px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .el-button {
          flex: 1;
          background: #165dff;
          border-radius: 12px 12px 12px 12px;
          border: none;
          font-weight: 500;
          font-size: 14px;
          color: #ecedee;
          &.el-button--primary {
            background: #165dff;
            &:hover {
              background: #165dff !important;
            }
          }
          &.el-button--default {
            background: #3f3f46;
          }
        }
      }
    }
    .el-dialog__footer {
      display: none;
    }
  }
}
</style>
